import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ClickOutside from "vue-click-outside";
import { mapGetters, mapActions, mapState } from "vuex";
import { BoardColumnSortMixin } from "@Shared/utils/board-mixins";
import defaultState from "@Broker/@Modules/clients/board/store/board-default-state";
import SettingsColumn from "./settings-column";
import { MOVE_BOARD_PROFILE, UPDATE_STATE_COLUMN_CONFIG, UPDATE_STATE_COLUMN_LABEL, MOVE_STATUS_COLUMN, DELETE_STATUS_COLUMN } from "@Broker/@Modules/clients/board/store/board-actions";
import { FIRST_COLUMN, SELECTED_BOARD, SELECTED_BOARD_FILTERS } from "@Broker/@Modules/clients/board/store/board-getters";
import ClientProfileList from "./virtual-draggable-list/client-profile-list";
import { cloneDeep, difference, isEqual } from "lodash";
import { SORT_ORDER_E } from "@Shared/js/enum";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "StatusColumn",
  components: {
    SettingsColumn,
    ClientProfileList
  },
  directives: {
    ClickOutside
  },
  mixins: [BoardColumnSortMixin],
  props: {
    count: {
      type: Number,
      default: 0
    },
    hasEmailAutomation: {
      type: Boolean,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    muteAutomations: {
      type: Boolean,
      required: true
    },
    muteNotifications: {
      type: Boolean,
      required: true
    },
    order: {
      type: Array,
      default: () => []
    },
    rottingDaysThreshold: {
      type: Number,
      required: true
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      movedElement: null,
      showingSettings: false,
      editing: false,
      newLabel: "",
      clickOutsideNonce: 0
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("BoardStore", {
    clientProfileSearchString: state => state.clientProfileSearchString,
    clientProfilesById: state => state.clientProfiles.byId
  })), mapGetters("BoardStore", [FIRST_COLUMN, SELECTED_BOARD, SELECTED_BOARD_FILTERS])), {}, {
    isFirstColumn() {
      return this.FIRST_COLUMN.id === this.id;
    },
    sortBy() {
      return this.SELECTED_BOARD.sortBy;
    },
    hasActiveSort() {
      return this.sortBy !== "none";
    },
    hasActiveFilters() {
      return !isEqual(this.SELECTED_BOARD_FILTERS, defaultState.defaultFilters);
    },
    hasActiveSearch() {
      return this.clientProfileSearchString.length >= 3;
    },
    needsFullProfileList() {
      return this.hasActiveSort || this.hasActiveFilters || this.hasActiveSearch;
    },
    noActivityFirst() {
      return this.SELECTED_BOARD.noActivityFirst;
    },
    columnProfileIds() {
      return this.order;
    },
    columnProfiles() {
      var _context, _context2;
      const profiles = _filterInstanceProperty(_context = _mapInstanceProperty(_context2 = this.columnProfileIds).call(_context2, id => this.clientProfilesById[id])).call(_context, Boolean);
      if (this.hasActiveSearch) {
        return this.searchClientProfile(profiles, this.clientProfileSearchString);
      }
      return profiles;
    },
    sortedProfiles() {
      if (!this.hasActiveSort) return this.filteredProfiles;
      return this.sortProfileCardsBy(this.filteredProfiles, {
        criteria: this.sortBy,
        emptyAtTop: this.noActivityFirst,
        order: this.sortBy === "createdAt" || this.sortBy === "clientValue" || this.sortBy === "clientLabel" ? this.sortByOrder : SORT_ORDER_E.asc
      });
    },
    filteredProfiles() {
      if (!this.hasActiveFilters) return this.columnProfiles;
      return this.filterProfileCards(this.columnProfiles, this.SELECTED_BOARD_FILTERS);
    },
    profilesValues: {
      get() {
        var _context3;
        return this.needsFullProfileList ? _mapInstanceProperty(_context3 = this.sortedProfiles).call(_context3, ({
          id
        }) => id) : this.columnProfileIds;
      },
      set(value) {
        const currentValue = this.profilesValues;
        if (currentValue.length < value.length) {
          const [movedProfileId] = difference(value, currentValue);
          const movedProfile = this.clientProfilesById[movedProfileId];
          if (!movedProfile) return;
          this.MOVE_BOARD_PROFILE({
            movedProfile: _objectSpread(_objectSpread({}, movedProfile), {}, {
              status: this.label,
              statusLabelId: this.id
            }),
            fromStatus: movedProfile.statusLabelId,
            toStatus: this.id,
            toOrder: value
          });
        } else if (currentValue.length === value.length) {
          const movedProfile = this.movedElement;
          if (!movedProfile) return;
          this.MOVE_BOARD_PROFILE({
            movedProfile: _objectSpread(_objectSpread({}, movedProfile), {}, {
              status: this.label,
              statusLabelId: this.id
            }),
            fromStatus: movedProfile.statusLabelId,
            toStatus: this.id,
            toOrder: value
          });
        }
      }
    },
    computedValue() {
      var _context4;
      return !this.hasActiveFilters ? this.value : _reduceInstanceProperty(_context4 = this.filteredProfiles).call(_context4, (acc, curr) => acc + _parseInt(curr.value), 0);
    },
    sortByOrder() {
      return this.SELECTED_BOARD.sortByOrder;
    }
  }),
  watch: {
    computedValue: {
      immediate: true,
      handler(newValue, oldValue) {
        this.animateColumnValue(newValue, oldValue);
      }
    },
    editing(value) {
      if (!value) return;
      this.$nextTick(() => {
        this.$refs.newLabelInput.focus();
      });
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions("BoardStore", [MOVE_BOARD_PROFILE, UPDATE_STATE_COLUMN_CONFIG, UPDATE_STATE_COLUMN_LABEL, MOVE_STATUS_COLUMN, DELETE_STATUS_COLUMN])), {}, {
    formatMoneyValue(value) {
      return this.$options.filters.formatMoneyValue(value);
    },
    onMove(event) {
      const draggedProfile = event.draggedContext.element;
      const draggedProfileId = typeof draggedProfile === "string" ? draggedProfile : draggedProfile == null ? void 0 : draggedProfile.id;
      this.movedElement = this.clientProfilesById[draggedProfileId];
    },
    toggleShowSettings() {
      this.showingSettings = !this.showingSettings;
    },
    handleConfigChange(config) {
      this.UPDATE_STATE_COLUMN_CONFIG(_objectSpread({
        statusLabelId: this.id
      }, config));
    },
    handleColumnMove(dir) {
      this.MOVE_STATUS_COLUMN({
        statusLabelId: this.id,
        dir
      });
    },
    handleDelete() {
      this.DELETE_STATUS_COLUMN({
        statusLabelId: this.id,
        defaultColumn: this.FIRST_COLUMN
      });
    },
    animateColumnValue(newValue = 0, oldValue = 0) {
      this.$nextTick(() => {
        const target = this.$refs.clientProfileValue;
        $(target).prop("number", oldValue).animateNumber({
          number: newValue,
          numberStep: (now, tween) => {
            const target = $(tween.elem);
            target.text(this.formatMoneyValue(now));
          }
        });
      });
    },
    setEditing(editing) {
      this.editing = editing;
      if (this.editing) {
        this.newLabel = cloneDeep(this.label);
      }
    },
    handleLabelSubmit() {
      if (!this.newLabel) return;
      this.editing = false;
      if (this.newLabel === this.label) return;
      this.UPDATE_STATE_COLUMN_LABEL({
        statusLabelId: this.id,
        label: this.newLabel
      });
    },
    handleAutomationDefinedClick() {
      window.location = `#/automation/automations?path=trigger-arguments.status.value&value=
       ${this.id}`;
    },
    handleClickOutside() {
      if (!this.editing) return;
      this.clickOutsideNonce++;
      if (this.clickOutsideNonce > 1) {
        this.clickOutsideNonce = 0;
        this.setEditing(false);
      }
    },
    handleDraggableStart(event) {
      const movedElementIndex = event.oldIndex;
      const movedProfileId = this.profilesValues[movedElementIndex];
      this.movedElement = this.clientProfilesById[movedProfileId];
    },
    handleDraggableEnd() {
      this.movedElement = null;
    }
  })
});